import _ from 'lodash'

import DataType from 'scoreboard/datasets/model/data-type'
const { CONTINENT, COUNTRY, STATE_PROVINCE, COUNTY, POSTAL_CODE, VOTING_DISTRICT, CITY, LATITUDE, LONGITUDE, LATITUDE_LONGITUDE,  } = DataType;

/**
 * Returns whether a dataType can be considered geographic
 *
 * @param {String} dataType a valid DataType
 * @return {boolean} true if dataType fits into the geographic data supertype
 */
function isGeographicDataType(dataType) {
	return _.includes([CONTINENT, COUNTRY, STATE_PROVINCE,
		COUNTY, POSTAL_CODE, VOTING_DISTRICT, CITY, LATITUDE,
		LONGITUDE, LATITUDE_LONGITUDE], dataType)
}

export default isGeographicDataType
isGeographicDataType.__filename__ = 'components/is-geographic-data-type.js'
